module.exports = __webpack_public_path__ + "img/pk1.9ae763af.svg";